import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { Button } from '@mui/material';

import SignInIcon from './assets/sign-in.svg';
import useStyles from './styles';

interface Props {
    className?: string;
}

const SignInButton: React.FC<Props> = ({ className }) => {
    const { classes, cx } = useStyles();
    const location = useLocation();

    const to = useMemo(() => {
        const pathname = '/login';
        return {
            pathname,
            /** Do not redirect back to login */
            state: location.pathname === pathname ? location.state : location.pathname + location.search
        };
    }, [location.pathname, location.search, location.state]);

    return (
        <div className={cx(classes.container, className)}>
            <Button
                fullWidth
                disableElevation
                disableRipple
                disableFocusRipple
                variant="contained"
                component={Link}
                to={to}
                endIcon={<SignInIcon />}
                className={cx(classes.regular)}
            >
                {'Sign in'}
            </Button>
        </div>
    );
};

export default SignInButton;
